import { ChangeDetectorRef, Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import CountriesJSON from 'src/assets/data/einvoice-countries.json';

@Component({
  selector: 'app-einvoice-countries-select',
  templateUrl: './einvoice-countries-select.component.html',
  styleUrls: ['./einvoice-countries-select.component.less'],
  styles: [],
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EInvoiceCountriesSelectComponent),
      multi: true
    }
  ]
})
export class EInvoiceCountriesSelectComponent
  implements ControlValueAccessor
{
  options = [...CountriesJSON];

  @Input() value: string = '';
  @Input() disabled = false;
  @Input() borderless = false;
  @Input() isRequired = false;

  get readonly() {
    if (this.disabled) {
      return true;
    }
    return false;
  }

  get displayText() {
    const item = this.options.find(x => x.code === this.value);
    if (item) return `${item.code}`;
    return '';
  }

  onChange: any = () => {};
  onTouched: any = () => {};
  constructor(private cdr: ChangeDetectorRef) {}

  writeValue(value: string): void {
    this.value = value;
    this.onChange(value);
    this.cdr.markForCheck();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onModelChange(val: any) {
    this.value = val;
    this.onChange(val);
    this.cdr.markForCheck();
  }
}
